// Header clicks
const headerLinks = Array.from(document.querySelectorAll('nav a'));
headerLinks.forEach((link) => {
    link.addEventListener('click', () => {
        if (!link.href) return;
        const section = link.closest('.js-nav-flyout');
        dataLayer.push({
            'event': 'genericHeaderClick',
            'brand': 'Lifebroker',
            'pageName':  document.title, //i.e. Homepage
            'clickSection': section && section.dataset.section, //i.e. Insurance Product if insurance product or a link under it was clicked, Our Insurers if our insurers or a link under it was clicked.
            'clickType': 'Header Click', //e.g. Header Click
            'clickText': link.innerText, //e.g. “Insurance Products”, “Income Protection Insurance”, “Life & Work”
            'clickUrl': link.href, //e.g. https://www.lifebroker.com.au/income-protection
        });
    });
});

// Click to call links
const callLinks = Array.from(document.querySelectorAll('.adobe-track-call'));
callLinks.forEach((link) => {
    link.addEventListener('click', () => {
        dataLayer.push({
            'event': 'clickToCall',
            'brand': 'Lifebroker',
            'pageName': document.title, //i.e. Homepage, “Contact Us | Lifebroker”
            'clickSection': link.dataset.section, //e.g. “Header”, “Footer”, “Contact Us”  
            'clickType': 'Click to Call',
            'clickText': link.innerText.trim(), //e.g. “13 54 33”
            'clickUrl': link.href, //e.g.“tel:13 54 33”
        });
    });
});

// Cta (green) buttons
const ctaLinks = Array.from(document.querySelectorAll('.adobe-track-cta, .hero__cta, .btn--lima, .cta-inline__btn'));
const track = (link) => {
    const section = link.closest('[data-section]');
    dataLayer.push({
        'event': 'ctaClick',
        'brand': 'Lifebroker',
        'pageName': document.title, //i.e. “Homepage”, “Life Insurance” 
        'clickSection': section && section.dataset.section, //e.g. “Header”, “Compare Life Insurance”, “Compare Life Insurance Quotes in Minutes”
        'clickType': 'CTA Click',
        'clickText': link.innerText.trim(), //e.g. “Compare Insurance”, “Compare Life Insurance”
        'clickUrl': link.href, //e.g. 
    });
};
window.adobeTrackCta = track;
ctaLinks.forEach((link) => {
    link.addEventListener('click', () => track(link));
});

// Generic (outline) buttons
const genericButtons = Array.from(document.querySelectorAll('.adobe-track-button, .btn--lima-outline'));
genericButtons.forEach((link) => {
    const section = link.closest('[data-section]');
    link.addEventListener('click', () => {
        dataLayer.push({
            'event': 'buttonClick',
            'brand': 'Lifebroker',
            'pageName': document.title, //i.e.“Life Insurance” 
            'clickSection': section && section.dataset.section, //e.g. “Are life insurance premiums tax deductible?”
            'clickType': 'Button Click',
            'clickText': link.innerText.trim(), //e.g. “I’ve got more questions”
            'clickUrl': link.href, //e.g. https://www.lifebroker.com.au/faqs?section=life-insurance
        });
    });
});

// link clicks
const links = Array.from(document.querySelectorAll('a'));
links.forEach((link) => {
    // Don't fire if button or footer link click
    if (link.classList.toString().match(/btn|button|cta|footer/)) return;
    const section = link.closest('[data-section]');
    link.addEventListener('click', () => {
        dataLayer.push({
            'event': 'linkClick',
            'brand': 'Lifebroker',
            'pageName': document.title, //i.e.“Life Insurance” 
            'clickSection': section && section.dataset.section, //e.g. “Are life insurance premiums tax deductible?”
            'clickType': 'Link Click',
            'clickText': link.innerText.trim(), //e.g. “I’ve got more questions”
            'clickUrl': link.href, //e.g. https://www.lifebroker.com.au/faqs?section=life-insurance
        });
    });
});

// Search Results
const search = document.querySelector('#search-stats');
const urlParams = new URLSearchParams(window.location.search);
if (search) {
    const poll = setInterval(() => {
        const results = document.querySelector('.ais-stats--body');
        if (results) {
            clearInterval(poll);
            dataLayer.push({
                'event': 'siteSearch',
                'brand': 'Lifebroker',
                'searchTerm': urlParams.get('q'), //e.g. “Life insurance”, “what is tpd insurance”
                'searchResults': results.innerText.match(/\d/)[0], //e.g. “10”, “7”, “4”
                'clickSection': 'Header Click',
                'clickType': 'Search Click'
            });
        }
    }, 500);
}


// footer clicks
const footerLinks = Array.from(document.querySelectorAll('.footer__main a'));
footerLinks.forEach((link) => {
    if (link.classList.contains('adobe-track-call')) return;
    const section = link.closest('[data-section]');
    link.addEventListener('click', () => {
        dataLayer.push({
            'pageName': document.title, //i.e.“Life Insurance” 
            'clickSection': section && section.dataset.section, //e.g. “Are life insurance premiums tax deductible?”
            'clickText': link.innerText.trim(), //e.g. “I’ve got more questions”
            'clickUrl': link.href, //e.g. https://www.lifebroker.com.au/faqs?section=life-insurance
            'event':'footerClick',
            'brand':'Lifebroker',
            'clickType':'Footer Click'
        });
    });
});

// Brand clicks
const brandLinks = Array.from(document.querySelectorAll('.insurer-list a'));
brandLinks.forEach((link) => {
    link.addEventListener('click', () => {
        dataLayer.push({
            'pageName': document.title, //i.e.“Life Insurance” 
            'clickSection': 'Insurer Cards', //e.g. “Are life insurance premiums tax deductible?”
            'clickText': `${link.dataset.product} - ${link.innerText.replace(/(\n)/gm, " - ").trim()}`, //e.g. “I’ve got more questions”
            'clickUrl': link.href, //e.g. https://www.lifebroker.com.au/faqs?section=life-insurance
            'brand':'Lifebroker',
            'event':'brandClick',
            'clickType':'Brand Click'
        });
    });
});

// PDF downloads
const pdfLinks = Array.from(document.querySelectorAll('.footer__smallprint a'));
pdfLinks.forEach((link) => {
    link.addEventListener('click', () => {
        dataLayer.push({
            'event': 'download',
            'brand': 'Lifebroker',
            'pageName': document.title, //i.e.“Homepage”, “Life Insurance” 
            'clickSection': 'Footer', //e.g. “Footer”
            'clickType': 'PDF Download',
            'clickText': link.innerText.trim(), //e.g. “Lifebroker Financial Services Guide”
            'clickUrl': link.href,  //e.g. 
        });
    });
});

// faq clicks
const trackFaq = (section, action, text) => {
    dataLayer.push({
        'event': 'faqLink',
        'brand': 'Lifebroker',
        'pageName': document.title, //i.e.“Lifebroker FAQs”
        'clickSection': `${section} faq`, //e.g. “Life Insurance FAQ”, “Income Protection FAQ”
        'clickType': action, //e.g. “Expand” or “Contract”
        'clickText': text, //e.g. “What is life insurance?”, “How much cover do I need?”
        'clickUrl': window.location.href
    });
}
window.adobeTrackFaq = trackFaq;


// faq topic clicks
const trackFaqTopic = (text) => {
    dataLayer.push({
        'event': 'faqTile',
        'brand': 'Lifebroker',
        'pageName': document.title, //i.e.“Lifebroker FAQs”
        'clickSection': 'Answers by Topic', 
        'clickType': 'FAQ Tile Click', //e.g. “Expand” or “Contract”
        'clickText': text, //e.g. “Life Insurance”, “Key Person Insurance”
        'clickUrl': window.location.href,  //e.g. 
    });
}
window.adobeTrackFaqTopic = trackFaqTopic;


// Comparison app links
const comparisonLinks = Array.from(document.querySelectorAll('.landing__btn'));
comparisonLinks.forEach((link) => {
    link.addEventListener('click', () => {
        dataLayer.push({
            'event': 'formStart',
            'brand': 'Lifebroker',
            'pageName': 'Lifebroker Comparison', 
            'clickSection': link.href.includes('life') ? 'Life Insurance' : 'Income Protection Insurance',
            'clickType': 'Comparison Funnel', 
            'clickText': link.innerText.trim(), //e.g. “Compare”
            'clickUrl': link.href,  //e.g.  
        });
    });
});